export const calculateTPSLFromPnL = ({
    entryPrice,
    amount,
    leverage,
    tpPnl,
    slPnl,
    typeTrade,
    decimalToken,
    isClaim = true,
}: {
    entryPrice: number;
    amount: number;
    leverage: number;
    tpPnl: number;
    slPnl: number;
    typeTrade: string;
    decimalToken: number;
    isClaim?: boolean;
}) => {
    const positionSize = amount * leverage;

    if ((tpPnl === 0 || tpPnl > amount * 9) && isClaim) {
        tpPnl = amount * 9;
    }
    const tpPercent = tpPnl / positionSize;
    const slPercent = slPnl / positionSize;

    const tpPrice =
        typeTrade === 'Long'
            ? entryPrice * (1 + tpPercent)
            : entryPrice * (1 - tpPercent);

    const slPrice =
        typeTrade === 'Long'
            ? entryPrice * (1 - slPercent)
            : entryPrice * (1 + slPercent);

    return {
        takeProfit: Number(tpPrice) < 0 ? '0' : tpPrice.toFixed(decimalToken),
        stopLoss: slPnl > 0 ? slPrice.toFixed(decimalToken) : '0',
    };
};

export const calculateTPSLPercent = ({
    entryPrice,
    tpPrice,
    slPrice,
    typeTrade,
    leverage, // mặc định x1
}: {
    entryPrice: number;
    tpPrice?: number;
    slPrice?: number;
    typeTrade: 'Long' | 'Short';
    leverage: number;
}) => {
    let tpPercent = 0;
    let slPercent = 0;

    if (tpPrice && tpPrice > 0) {
        tpPercent =
            typeTrade === 'Long'
                ? ((tpPrice - entryPrice) / entryPrice) * 100
                : ((entryPrice - tpPrice) / entryPrice) * 100;
    }

    if (slPrice && slPrice > 0) {
        slPercent =
            typeTrade === 'Long'
                ? ((entryPrice - slPrice) / entryPrice) * 100
                : ((slPrice - entryPrice) / entryPrice) * 100;
    }

    return {
        tpPercent: Number((tpPercent * leverage).toFixed(2)),
        slPercent: Number((slPercent * leverage).toFixed(2)),
    };
};

export const calculateTPSLFromPercent = ({
    entryPrice,
    amount,
    leverage,
    tpPercent, // % TP theo amount (vốn bỏ ra)
    slPercent, // % SL theo amount (vốn bỏ ra)
    typeTrade,
    decimalToken,
}: {
    entryPrice: number;
    amount: number;
    leverage: number;
    tpPercent: number;
    slPercent: number;
    typeTrade: 'Long' | 'Short';
    decimalToken: number;
}) => {
    // Giới hạn %

    const tpPercentLimited = Math.min(tpPercent, 900);
    const slPercentLimited = Math.min(slPercent, 100);

    // Position size
    const positionSize = amount * leverage;

    // Quy đổi % vốn -> PnL tuyệt đối
    const tpPnL = (tpPercentLimited / 100) * amount;
    const slPnL = (slPercentLimited / 100) * amount;

    // Từ PnL -> % thay đổi giá
    const tpRatio = tpPnL / positionSize;
    const slRatio = slPnL / positionSize;

    const tpPrice =
        typeTrade === 'Long'
            ? entryPrice * (1 + tpRatio)
            : entryPrice * (1 - tpRatio);

    const slPrice =
        typeTrade === 'Long'
            ? entryPrice * (1 - slRatio)
            : entryPrice * (1 + slRatio);

    return {
        takeProfit: tpPercent > 0 ? tpPrice.toFixed(decimalToken) : '0',
        stopLoss: slPercent > 0 ? slPrice.toFixed(decimalToken) : '0',
    };
};
